import React from 'react'
import { InputAdornment } from '@mui/material'
import {
  AppointmentTime,
  DoctorInfo,
  DoctorName,
  MenuTitle,
  PatientInfo,
  PatientMRN,
  PatientName,
  PatientNameText,
  ProcedureName,
  RoomNumber,
  SearchField,
  StyledMenu,
  StyledMenuItem,
  StyledSearchIcon,
  EmptyStateContainer,
  EmptyStateText,
  StyledTabs,
  StyledTab,
  TabContent,
} from './AddPatientMenu.styles'
import { TAddPatientMenuProps } from './AddPatientMenu.types'
import { useAddPatientMenuLogic } from './AddPatientMenu.logic'
import {
  getProviderName,
  getSurgeryDescription,
  getTimeFromDate,
} from '../helpers'

const AddPatientMenu: React.FC<TAddPatientMenuProps> = (props) => {
  const { anchorEl, roomName } = props
  const logic = useAddPatientMenuLogic(props)

  return (
    <StyledMenu
      anchorEl={anchorEl}
      open={!!anchorEl}
      onClose={logic.handleClose}
    >
      <MenuTitle>{`Add patient to ${roomName}`}</MenuTitle>

      {logic.showTabs && (
        <StyledTabs
          value={logic.activeTab}
          onChange={logic.handleTabChange}
          variant="fullWidth"
        >
          <StyledTab
            label={`Waiting (${logic.filteredWaitingPatients.length})`}
          />
          <StyledTab
            label={`Scheduled (${logic.filteredScheduledPatients.length})`}
          />
        </StyledTabs>
      )}

      <SearchField
        placeholder={logic.getSearchPlaceholder()}
        value={logic.searchQuery}
        onChange={(e) => logic.setSearchQuery(e.target.value)}
        onKeyDown={(e) => {
          e.stopPropagation()
        }}
        fullWidth
        size="small"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <StyledSearchIcon />
            </InputAdornment>
          ),
        }}
      />

      <TabContent>
        {logic.currentTabPatients.length === 0 ? (
          <EmptyStateContainer>
            <EmptyStateText variant="body2" color="text.secondary">
              {logic.getEmptyStateMessage()}
            </EmptyStateText>
          </EmptyStateContainer>
        ) : (
          logic.currentTabPatients.map((surgery) => (
            <StyledMenuItem
              key={surgery._id}
              onClick={() => logic.handleAddPatient(surgery)}
            >
              <PatientInfo>
                <PatientName>
                  <PatientNameText>
                    {`${
                      surgery.patient.lastName
                    }, ${surgery.patient.firstName[0].toUpperCase()}`}
                  </PatientNameText>
                  <PatientMRN>• MRN{surgery.patient.idMR}</PatientMRN>
                </PatientName>
                <DoctorInfo>
                  <DoctorName>
                    {getProviderName(surgery.attendingProvider)}
                  </DoctorName>
                  <AppointmentTime>
                    • {getTimeFromDate(surgery.procedure.dateTime)}
                    {surgery.patientStatusHistory[0]?.info?.room && (
                      <RoomNumber>
                        • {surgery.patientStatusHistory[0].info.room.name}
                      </RoomNumber>
                    )}
                  </AppointmentTime>
                </DoctorInfo>
                {logic.roomViewSettings.showProcedureName && (
                  <ProcedureName>
                    {getSurgeryDescription(surgery)}
                  </ProcedureName>
                )}
              </PatientInfo>
            </StyledMenuItem>
          ))
        )}
      </TabContent>
    </StyledMenu>
  )
}

export default AddPatientMenu
